import React, {useEffect, useState} from 'react';

import {useDebounceState} from '../../../util/hooks';
import {useStatsigGateMultiMetricQuickAdd} from '../../../util/rampFeatureFlags';
import {MultiMetricPanelAdd} from './MultiMetricPanelAdd';
import {usePanelsQuickAddContext} from './PanelsQuickAddContext';
import {SingleKeyPanelAdd} from './SingleKeyPanelAdd';

export const PanelsQuickAdd = () => {
  const isMultiMetricQuickAddEnabled = useStatsigGateMultiMetricQuickAdd();

  const {initialSearchStr} = usePanelsQuickAddContext();
  const [searchStr, dSearchStr, setSearchStr] = useDebounceState(
    initialSearchStr,
    200
  );
  useEffect(
    () => setSearchStr(initialSearchStr),
    [initialSearchStr, setSearchStr]
  );

  const [isMultiMetricFormOpen, setIsMultiMetricFormOpen] = useState(false);
  if (isMultiMetricQuickAddEnabled && isMultiMetricFormOpen) {
    return (
      <MultiMetricPanelAdd
        onBack={() => setIsMultiMetricFormOpen(false)}
        initialRegex={searchStr}
      />
    );
  }

  return (
    <SingleKeyPanelAdd
      searchStr={searchStr}
      dSearchStr={dSearchStr}
      setSearchStr={setSearchStr}
      openMultiMetricForm={() => setIsMultiMetricFormOpen(true)}
    />
  );
};
